/**
 * numeric html chars to utf8
 */
export function decodeHtml(html) {
  return html.replace(/&#(\d+);/g, function(match, dec) {
    return String.fromCharCode(dec)
  })
}
